import { RotateCcwIcon } from 'lucide-react';

import type { SuggestionError } from '@/chat/types';
import { Button } from '@/components/ui/button';

interface ErrorBubbleProps {
  error: SuggestionError;
  onRetry: () => void;
  retryDisabled: boolean;
}

// 백엔드 error_message는 내부 예외 문자열이라 노출하지 않음 (useSuggestion에서 로깅)
export const ErrorBubble = ({ error, onRetry, retryDisabled }: ErrorBubbleProps) => (
  <div className="flex flex-col items-start gap-2">
    <p className="text-destructive text-sm">
      {error.retryable
        ? '일시적인 오류가 발생했습니다. 다시 시도해 주세요'
        : '요청을 처리할 수 없습니다. 입력을 바꿔 다시 보내 주세요'}
    </p>
    {error.retryable && (
      <Button disabled={retryDisabled} onClick={onRetry} size="sm" variant="outline">
        <RotateCcwIcon />
        다시 시도
      </Button>
    )}
  </div>
);
